export const uint32ArrayFromString = (string: string): Uint32Array =>
  new Uint32Array(string.split(',').map((it) => +it));

export const uint32ArrayToString = (array: Uint32Array) => array.join(',');
